(function () {
  const toggles = document.querySelectorAll('.category .toggle');
  toggles.forEach((toggle) => {
    const content = toggle.nextElementSibling;
    const plusIcon = toggle.querySelector('.plus');
    const minusIcon = toggle.querySelector('.minus');
    toggle.addEventListener('click', function () {
      if (content.style.display === 'none' || content.style.display === '') {
        content.style.display = 'grid';
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';
      } else {
        content.style.display = 'none';
        plusIcon.style.display = 'block';
        minusIcon.style.display = 'none';
      }
    });
  });
})();
